import basicTheme from '../basicTheme.js';

const menuStyleOverrides = {
    defaultProps: {
        anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
        transformOrigin: { vertical: 'top', horizontal: 'right' },
    },
    styleOverrides: {
        root: {
            '*::-webkit-scrollbar': {
                display: 'none',
            },
        },
        paper: {
            borderRadius: '3px',
            backgroundColor: 'transparent !important',
        },
        list: {
            color: basicTheme.palette.N20.main,
            backgroundColor: basicTheme.palette.N40.main,
        },
    },
};

export { menuStyleOverrides as default };
//# sourceMappingURL=MuiMenu.js.map
